import { render, staticRenderFns } from "./detail_bonus_page.vue?vue&type=template&id=1d0fbfe2&scoped=true"
import script from "./detail_bonus_page.vue?vue&type=script&lang=js"
export * from "./detail_bonus_page.vue?vue&type=script&lang=js"
import style0 from "./detail_bonus_page.vue?vue&type=style&index=0&id=1d0fbfe2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0fbfe2",
  null
  
)

export default component.exports